import React from 'react';

import { Grid, Section } from '@gogame/components';
import { FormField, withForm, SidePageV2 } from '@gogame/form';

import * as CONCEPT_FAMILY from 'scenes/Gallery/GalleryPage/ConceptFamilies/constants';
import { loadConcepts } from 'scenes/Gallery/GalleryPage/ConceptFamilies/sources/fields';
import { loadThumbnails } from 'scenes/Gallery/GalleryPage/ConceptFamilies/sources/fields';
import { useUploadAttachments } from 'scenes/Gallery/GalleryPage/ConceptFamilies/data';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';

import FamilyThumbnailFormField from './components/FamilyThumbnailFormField';

const ConceptFamilyForm = withForm({
  initialNormalized: false,
  enableReinitialize: true,
})(({
  children,
  title,
  values,
  loading,
  onClose,
  onExited,
  open,
  entityId,
}) => {
  const { isAllowAttachments } = useGalleryPermissions();

  const uploadAttachments = useUploadAttachments();

  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
      size={'lg'}
    >
      <SidePageV2.Title title={title} entityId={entityId} />
      <SidePageV2.NewBody>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormField.TextField
              label={'Name'}
              required={true}
              name={CONCEPT_FAMILY.NAME}
              padding={0}
              debounceTimeout={500}
            />
          </Grid>
          <Grid item xs={12}>
            <FormField.MultiSelect
              label={`Concepts`}
              name={CONCEPT_FAMILY.CONCEPTS}
              source={loadConcepts}
              padding={0}
              required={values.id}
            />
          </Grid>
          <Grid item xs={12}>
            <FormField.TextField
              label={'Description'}
              name={CONCEPT_FAMILY.DESCRIPTION}
              padding={0}
              debounceTimeout={500}
            />
          </Grid>
          <Grid item xs={12}>
            <FamilyThumbnailFormField
              label={`Family Thumbnail`}
              required={values.id}
              name={CONCEPT_FAMILY.ORIGINAL_CONCEPT}
              source={loadThumbnails}
              depends={[CONCEPT_FAMILY.CONCEPTS]}
            />
          </Grid>
        </Grid>
        {isAllowAttachments ? (
          <Section title={'Attachments'}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <FormField.AttachmentField
                  name={CONCEPT_FAMILY.ATTACHMENTS}
                  label={'Select files'}
                  tooltip={'Only pdf or jpg (jpeg) files are allowed'}
                  accept={'.pdf, .jpg, .jpeg'}
                  onUpload={uploadAttachments}
                  variant={'outlined'}
                  multiple={true}
                  padding={0}
                />
              </Grid>
            </Grid>
          </Section>
        ) : null}
      </SidePageV2.NewBody>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
      {children}
    </SidePageV2>
  );
});

export default ConceptFamilyForm;
